import el from "@cypherpotato/el";
import { DataPickerControl } from "./data-picker";
import { TextInput } from "./form";
import { Content } from "./layout";
import { MutedText } from "./text";

export default function InputListBox({ items, placeholder, onRemove = null }) {
    const selectedItem = el.state.create(null);
    const isUsingCustomInput = el.state.create(false);

    var textBoxEditor;

    return el("div.input-list-box",
        {
            $properties: {
                value: {
                    get() {
                        return selectedItem.value;
                    }
                }
            }
        },
        el(".list-box-items",
            items?.length && el.state.listening([selectedItem, isUsingCustomInput], () =>
                Content(
                    DataPickerControl({
                        data: items,
                        value: !isUsingCustomInput.value && selectedItem.value,
                        onSelect(value) {
                            selectedItem.value = value;
                            isUsingCustomInput.value = false;
                            textBoxEditor.value = value;
                        },
                        onRemove
                    })
                )
            ) || MutedText("No items available.")
        ),
        el(".list-box-custom-input",
            TextInput(null, placeholder || "Type here...", {
                onInput(event) {
                    selectedItem.value = event.target.value;
                    isUsingCustomInput.value = true;
                },
                init() {
                    textBoxEditor = this;
                }
            })
        )
    )
}